import { compose } from 'recompose'
import syncsNote from './note'
import subscriptions from './subscriptions'

export const providesNotesSubscriptions = subscriptions
export default viewName => compose(syncsNote(viewName))
